import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import axiosInstance from "../../../../api/axios";
import { ROUTES } from "../../../../constants/routes";
import { languageHandler } from "../../../../utils/helpers";
import styles from "./ActorCard.module.scss";

type Props = {
  actorId: number
  fullName: string
  description: string
  image: string
}

const ActorCard = ({ actorId, fullName, description, image }: Props) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  const getResolvedActorId = async () => {
    try {
      const response = await axiosInstance.get("/person/", {
        params: {
          language: languageHandler(i18n.language),
          search: fullName,
          page: 1,
        },
      });

      const results = response.data?.results || [];
      const normalizedName = fullName.trim().toLocaleLowerCase();
      const exactMatch = results.find((actor: any) => actor.name?.trim().toLocaleLowerCase() === normalizedName);

      return exactMatch?.id || results[0]?.id || actorId;
    } catch {
      return actorId;
    }
  };

  const clickHandler = async () => {
    const resolvedActorId = await getResolvedActorId();
    navigate(`${ROUTES.ACTORS}/${resolvedActorId}`);
  };

  return (
    <div className={styles.wrapper} onClick={clickHandler}>
      <img
        width={130}
        height={130}
        className={styles.image}
        src={image ? image : ""}
        alt="#"
      />
      <div className={styles.textWrapper}>
        <h3 className={styles.fullName}>{fullName}</h3>
        <p className={styles.description}>{description}</p>
      </div>
    </div>
  )
}

export default ActorCard
